<template>
  <div>
    <div>
      <BNavbar class="cd-menu" fixed="top">
        <!--  Menu toggle  -->
        <button style="background: none; border: none; padding: 0; color: white" type="button" aria-label="Toggle menu">
          <font-awesome-icon class="cd-menu-toggle" icon="bars" @click="toggle"></font-awesome-icon>
        </button>

        <!--  Nav Branding  -->
        <router-link
          v-if="cdOrganisationAvailable"
          class="cd-menu-branding"
          :to="{ name: 'Dashboard' }"
          style="display: flex; color: white; text-decoration: none"
        >
          <span class="ml-2 align-middle font-weight-bold">{{ tenantName }} / </span>
          <div class="ml-2 font-weight-bold">{{ pageName }}</div>
        </router-link>
        <router-link v-else class="cd-menu-branding" :to="{ name: 'Dashboard' }">
          <div class="ml-2 align-middle font-weight-bold">{{ pageName }}</div>
        </router-link>
        <form action="" class="w-50 mx-auto hd-search">
          <div class="input-group ml-5">
            <div class="input-group-prepend">
              <span class="input-group-text bg-white" id="basic-addon1"
                ><font-awesome-icon :fixedWidth="true" :icon="['fas', 'magnifying-glass']" class="searchIcon"
              /></span>
            </div>
            <input
              ref="search"
              type="text"
              class="form-control"
              placeholder="Search..."
              @focus="showSearchBox()"
              @blur="hideSearchBox($event.relatedTarget)"
              v-model="searchValue"
              @input="getSearchValue()"
              id="search"
              aria-label="Search"
            />
          </div>
          <SearchView
            v-if="showSearchView"
            :showSearchView="showSearchView"
            :stylesData="stylesData"
            :searchedStylesData="searchedStylesData"
            @updateSearchView="showSearchView = false"
            @getEditStyleId="getEditStyleId"
            @setVisibleEdit="visibleEdit = true"
          ></SearchView>
        </form>
        <!--  Nav Sidebar  -->
        <HeaderSideMenuV1 id="menu-sidebar" v-model:visible="isVisible" />
        <!--  User Control Area  -->
        <UserAreaV1 />
      </BNavbar>
    </div>
    <EditStyle v-if="visibleEdit" :visibleEdit="visibleEdit" :editStyleId="editStyleId"></EditStyle>
  </div>
</template>
<script lang="ts">
import { ICDOrganisationDto } from "@/core/models/CDIdentityModels";
import { CDIdentityModule } from "@/core/store/modules/cd-identity-module";
import isEmpty from "lodash/isEmpty";
import get from "lodash/get";
import UserAreaV1 from "@/core/views/designlanguage/v1/UserAreaV1.vue";
import HeaderSideMenuV1 from "@/core/views/designlanguage/v1/HeaderSideMenuV1.vue";
import SearchView from "@/app/views/pages/SearchView.vue";
import EditStyle from "@/app/views/_components/EditStyle.vue";
import getEnv from "@/core/utils/env";
import { User } from "oidc-client";
import { StyleApi } from "@/api";
import { eventBus } from "@/main";
import { defineComponent } from "vue";
import { useToast } from "vue-toastification";
import { BNavbar } from "bootstrap-vue-next";

export default defineComponent({
  name: "HeaderV1",
  components: {
    HeaderSideMenuV1,
    UserAreaV1,
    SearchView,
    EditStyle,
    BNavbar
  },
  setup() {
    const styleApi = new StyleApi()!;
    return {
      styleApi
    };
  },
  data() {
    return {
      searchResult: Array as () => any,
      DEFAULT_TITLE: process.env.VUE_APP_TITLE as string,
      pageName: "",
      visibleEdit: false,
      searchValue: "",
      editStyleId: 0,
      stylesData: [] as any[],
      searchedStylesData: [] as any[],
      showSearchView: false,
      toast: null as any,
      isVisible: false
    };
  },
  created(): void {
    this.toast = useToast();
    eventBus.on("pageName", (data: any) => {
      this.pageName = data;
    });
    eventBus.on("stylesData", (data: any) => {
      this.stylesData = data;
    });
  },
  methods: {
    async showSearchBox(): Promise<void> {
      await this.styleApi
        .apiStyleGridGet("CreationTime", 0, 25)
        .then(async e => {
          this.stylesData = Object.assign([], e.data["items"]);
          this.showSearchView = true;
        })
        .catch(e => {
          this.toast.error(e.errorMsg, {
            toastClassName: "custom-error-toast",
            timeout: 5000
          });
        });
    },
    getEditStyleId(id: number): void {
      this.editStyleId = id;
    },
    hideSearchBox(event: EventTarget | null): void {
      if (event == null) this.showSearchView = false;
    },

    async getSearchValue(): Promise<void> {
      this.searchedStylesData = [];
      if (this.searchValue != "") {
        await this.styleApi.apiGetStylesGet(this.searchValue).then(async styles => {
          if (styles.data.length > 0) {
            for (let style of styles.data) {
              this.searchedStylesData.push(style);
            }
          } else {
            this.toast.error(this.$t("headerV1.noStyleFound") as string, {
              toastClassName: "custom-error-toast",
              timeout: 5000
            });
          }
        });
      }
    },
    update(): void {
      this.visibleEdit = false;
      window.close();
    },
    toggle() {
      this.isVisible = !this.isVisible;
    }
  },
  computed: {
    cdOrganisation(): ICDOrganisationDto {
      return CDIdentityModule.cdOrganisation;
    },
    cdOrganisationAvailable(): boolean {
      return !isEmpty(this.cdOrganisation);
    },
    tenantName(): string {
      const cdTenantId = get(this.oidcUser, "cd_tenant_id", "");
      const cdTenant = this.cdOrganisation.tenants.find(
        x => x.tenantId == cdTenantId && x.applicationId == getEnv("VUE_APP_IDENTITY_APPLICATION_ID")
      );
      sessionStorage.setItem("TenantName", cdTenant?.tenantShortName ?? "");
      return cdTenant?.tenantShortName ?? "";
    },
    oidcUser(): User | null {
      return (this as any).$store.getters.oidcUser;
    }
  }
});
</script>
<style scoped>
form.w-50.mx-auto.hd-search {
  position: relative;
}
.hd-search input.form-control {
  border: none !important;
  border-radius: 0 5px 5px 0px !important;
}
.hd-search #basic-addon1 {
  border: none !important;
  font-weight: bolder;
  border-radius: 5px 0 0 5px;
}
.cd-menu {
  background-color: #0054a6;
  color: white;
  z-index: 1050;
  padding: 10px;
}
</style>
